import type { Dictionnaire } from '../type';

export const auth: Dictionnaire['auth'] = {
  erreurs: {
    identifiants: '邮箱或密码错误',
    emailInvalide: '邮箱地址无效',
    compteExiste: '该邮箱已注册账号',
    motDePasseFaible: '密码强度太弱',
    tropDeTentatives: '尝试次数过多，请几分钟后再试',
    reseau: '无法连接，请检查网络',
    inattendue: '出了点问题，请稍后再试',
    parEmail: '请使用邮箱地址登录',
    age: 'Sirocco 仅面向 16 岁及以上的用户',
    pseudoPris: '该用户名已被占用',
    sessionExpiree: '登录已过期，请重新登录',
    motDePasseActuel: '当前密码不正确',
    sansProfil: '该账号还没有 Sirocco 资料。如果问题持续，请联系我们。',
    connexion: '无法登录',
  },
  champs: {
    email: '邮箱地址',
    exempleEmail: 'you@example.com',
    motDePasse: '密码',
    retourConnexion: '返回登录',
  },
  action: {
    incomplet: '此链接不完整。',
    expireNouveau: '此链接已过期或已被使用。请重新申请。',
    expire: '此链接已过期或已被使用。',
    sixCaracteres: '至少六个字符。',
    pasChange: '密码未能修改。链接可能已过期。',
    titreChange: '密码已修改',
    titreNouveau: '新密码',
    titreRetablie: '邮箱已恢复',
    titreConfirmee: '邮箱已确认',
    unInstant: '请稍候',
    nouveau: '新密码',
    changer: '修改我的密码',
    connecteToi: '现在可以用新密码登录了。',
    bienvenue: '你的账号已开通。欢迎！',
    ouvrir: '打开 Sirocco',
    continuerSite: '在网站上继续',
    pour: { avant: '为以下账号设置新密码：', apres: '。' },
  },
  spot: {
    impossible: '无法加入这个服务器',
    publics: '公开服务器',
    prives: '私人服务器',
    bientot: '即将开放',
    tuEsMembre: '你是这个服务器的成员',
    membre: '本服务器成员',
    badgePrive: '私人',
    reserve: '仅限成员',
    rechercher: '搜索城市或地区…',
    rechercherLabel: '搜索城市或地区',
    accesReserve: '仅限成员',
    rejoindre: '加入这个服务器',
    membres: (n: number) => `${n.toLocaleString('zh-CN')} 位成员`,
    aucun: (recherche: string) => `没有与“${recherche}”匹配的服务器`,
    prive: (nom: string) => `${nom} 是私人服务器：只有其成员才能进入。`,
  },
  confirmer: {
    titre: '确认你的邮箱',
    renvoye: '邮件已重新发送。',
    patiente: '邮件刚刚发出。请等一分钟再重新请求，也请查看垃圾邮件文件夹。',
    trop: '今天请求的邮件太多了。请明天再试，或查看垃圾邮件文件夹。',
    echec: '邮件未能发送。请重试。',
    renvoyer: '重新发送邮件',
    deconnecter: '退出登录',
    envoye: {
      avant: '一封确认邮件已发送至',
      apres: '。点击邮件中的链接即可进入应用。',
    },
  },
  oubli: {
    impossible: '发送失败',
    titre: '密码',
    consigne: '输入你的邮箱，我们会发送一个重置链接。',
    envoyer: '发送链接',
    envoye: (email: string) => `如果 ${email} 已注册账号，邮件正在路上。`,
  },
  connexion: {
    impossible: '无法登录',
    oublie: '忘记密码？',
    seConnecter: '登录',
    nouveau: '第一次使用 Sirocco？',
    inscrire: '注册',
  },
  personnaliser: {
    photoImpossible: '照片未能保存',
    impossible: '保存失败',
    titre: '完善你的资料',
    choisirPhoto: '选择我的头像',
    bio: '个人简介',
    bioExemple: '你在这里做什么、在找什么、之前住在哪里…',
    continuer: '继续',
  },
  inscription: {
    regles: {
      huit: '至少 8 个字符',
      casse: '包含大写和小写字母',
      chiffre: '至少一个数字或特殊字符',
    },
    manque: {
      prenom: '请输入你的名字',
      nom: '请输入你的姓氏',
      pseudo: '请选择一个用户名',
      email: '请输入你的邮箱地址',
      motDePasse: '请设置密码',
      naissance: '请输入你的出生日期',
    },
    naissanceInvalide: '出生日期无效',
    conditions: '你必须接受使用条款',
    impossible: '注册失败',
    titre: '注册',
    dejaInscrit: '已有账号？',
    seConnecter: '登录',
    prenom: '名字',
    nom: '姓氏',
    pseudo: '用户名',
    pseudoExemple: '例如：martin.pecheur',
    naissance: '出生日期',
    accepteLabel: '我接受 Sirocco 的使用条款和隐私政策',
    accepte: {
      debut: '我接受 Sirocco 的',
      cgu: '使用条款',
      et: '和',
      confidentialite: '隐私政策',
      fin: '。',
    },
    langues: '我会说的语言',
    languesAide: '使用你会说的语言的聚会排在列表前面。之后可以在个人资料中修改。',
    jeMInscris: '注册',
  },
};
